/* ==========================================================================
   Find Your College
   Type-ahead + A-Z browser over the store's live college collections.

   The section (sections/cmc-find-your-college.liquid) renders the college list
   into a JSON script tag. This file only handles behaviour, so adding a new
   college collection to the source menu is all that is ever needed - no code
   changes.

   Data shape:
     [ { "n": "Penn State",
         "u": "/collections/penn-state",
         "k": [ { "n": "Penn State Lacrosse", "u": "/collections/..." } ] } ]
   ========================================================================== */
(function () {
  'use strict';

  var ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  // Leading words that should not drive alphabetical placement.
  // "University of Virginia" files under V, "US Naval Academy" under N.
  var LEADING = /^(university of the|university of|college of|the university of|us |u\.s\. |usna |st\.|st |saint |the )\s*/i;

  function sortKey(name) {
    return String(name || '').replace(LEADING, '').trim().toLowerCase();
  }

  function firstLetter(name) {
    var k = sortKey(name);
    return k ? k.charAt(0).toUpperCase() : '';
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function highlight(name, term) {
    if (!term) return escapeHtml(name);
    var i = name.toLowerCase().indexOf(term.toLowerCase());
    if (i < 0) return escapeHtml(name);
    return escapeHtml(name.slice(0, i)) +
      '<mark>' + escapeHtml(name.slice(i, i + term.length)) + '</mark>' +
      escapeHtml(name.slice(i + term.length));
  }

  function matches(college, lowerTerm) {
    if (college.n.toLowerCase().indexOf(lowerTerm) > -1) return true;
    if (!college.k) return false;
    for (var i = 0; i < college.k.length; i++) {
      if (college.k[i].n.toLowerCase().indexOf(lowerTerm) > -1) return true;
    }
    return false;
  }

  /* Collections picked up by auto-discovery are flagged a:1 by the section.
     If one of them reads as a variant of a school already in the menu
     ("Penn State Lacrosse" vs "Penn State"), file it as a sub-collection of
     that school instead of listing it as a separate college. Everything else
     stays a college of its own. */
  function foldAutoDiscovered(list) {
    var parents = [];
    var autos = [];
    var i;

    for (i = 0; i < list.length; i++) {
      if (list[i].a) autos.push(list[i]);
      else parents.push(list[i]);
    }

    if (!autos.length) return list;
    if (!parents.length) return autos;

    // Longest parent name first so "Notre Dame Law" beats "Notre Dame".
    var byLength = parents.slice().sort(function (a, b) {
      return sortKey(b.n).length - sortKey(a.n).length;
    });

    for (i = 0; i < autos.length; i++) {
      var autoKey = sortKey(autos[i].n);
      var owner = null;

      for (var p = 0; p < byLength.length; p++) {
        var parentKey = sortKey(byLength[p].n);
        if (autoKey.length > parentKey.length && autoKey.indexOf(parentKey + ' ') === 0) {
          owner = byLength[p];
          break;
        }
      }

      if (owner) {
        owner.k = owner.k || [];
        owner.k.push({ n: autos[i].n, u: autos[i].u });
      } else {
        parents.push(autos[i]);
      }
    }

    return parents;
  }

  function init(root) {
    if (!root || root.hasAttribute('data-cmc-fyc-ready')) return;

    var dataEl = root.querySelector('[data-cmc-fyc-data]');
    var input = root.querySelector('[data-cmc-fyc-input]');
    var panel = root.querySelector('[data-cmc-fyc-panel]');
    var azBar = root.querySelector('[data-cmc-fyc-az]');
    var countEl = root.querySelector('[data-cmc-fyc-count]');
    if (!dataEl || !input || !panel || !azBar) return;

    var colleges;
    try {
      colleges = JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      colleges = [];
    }
    if (!colleges.length) return;

    colleges = foldAutoDiscovered(colleges);

    // One clean alphabetical order for both the list and the A-Z row.
    colleges.sort(function (a, b) {
      var ka = sortKey(a.n), kb = sortKey(b.n);
      return ka < kb ? -1 : ka > kb ? 1 : 0;
    });

    var viewLabel = root.getAttribute('data-view-label') || 'View';
    var emptyHtml = root.getAttribute('data-empty-html') || '';
    var activeLetter = null;
    var lastRendered = [];

    if (countEl) countEl.textContent = colleges.length;

    root.setAttribute('data-cmc-fyc-ready', '');

    /* ---------------- panel rendering ---------------- */

    function rowHtml(college, term) {
      var html = '<a class="cmc-fyc__row" href="' + escapeHtml(college.u) + '" role="option">' +
        '<span class="cmc-fyc__name">' + highlight(college.n, term) + '</span>' +
        '<span class="cmc-fyc__go">' + escapeHtml(viewLabel) + ' &rarr;</span></a>';

      if (college.k && college.k.length) {
        for (var i = 0; i < college.k.length; i++) {
          var sub = college.k[i];
          html += '<a class="cmc-fyc__sub" href="' + escapeHtml(sub.u) + '" role="option">' +
            '<span class="cmc-fyc__sub-name">' + highlight(sub.n, term) + '</span>' +
            '<span class="cmc-fyc__go">' + escapeHtml(viewLabel) + ' &rarr;</span></a>';
        }
      }
      return html;
    }

    function paint(list, term) {
      lastRendered = list;

      if (!list.length) {
        panel.innerHTML = '<div class="cmc-fyc__empty">' + emptyHtml + '</div>';
        open();
        return;
      }

      var html = '';
      for (var i = 0; i < list.length; i++) html += rowHtml(list[i], term);
      panel.innerHTML = html;
      open();
    }

    function open() {
      panel.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      panel.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
    }

    function clearLetters() {
      var buttons = azBar.querySelectorAll('button');
      for (var i = 0; i < buttons.length; i++) buttons[i].classList.remove('is-on');
      activeLetter = null;
    }

    /* ---------------- type-ahead ---------------- */

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearLetters();

      if (!term) {
        close();
        return;
      }

      var lower = term.toLowerCase();
      paint(colleges.filter(function (c) { return matches(c, lower); }), term);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      // Enter jumps straight to the top result.
      if (event.key === 'Enter') {
        var first = panel.querySelector('.cmc-fyc__row, .cmc-fyc__sub');
        if (panel.classList.contains('is-open') && first) {
          event.preventDefault();
          window.location.href = first.getAttribute('href');
        }
      }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim() && lastRendered.length) open();
    });

    /* ---------------- A-Z row ---------------- */

    var lettersInUse = {};
    for (var c = 0; c < colleges.length; c++) lettersInUse[firstLetter(colleges[c].n)] = true;

    ALPHABET.forEach(function (letter) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = letter;
      button.setAttribute('aria-label', letter);

      if (!lettersInUse[letter]) {
        button.disabled = true;
      } else {
        button.addEventListener('click', function () {
          input.value = '';
          var wasActive = activeLetter === letter;
          clearLetters();
          if (wasActive) {
            close();
            return;
          }
          activeLetter = letter;
          button.classList.add('is-on');
          paint(colleges.filter(function (college) {
            return firstLetter(college.n) === letter;
          }), '');
        });
      }

      azBar.appendChild(button);
    });

    var viewAll = document.createElement('button');
    viewAll.type = 'button';
    viewAll.className = 'cmc-fyc__all';
    viewAll.textContent = root.getAttribute('data-all-label') || 'View all';
    viewAll.addEventListener('click', function () {
      input.value = '';
      clearLetters();
      paint(colleges, '');
    });
    azBar.appendChild(viewAll);

    /* ---------------- dismiss ---------------- */

    document.addEventListener('click', function (event) {
      if (root.contains(event.target)) return;
      close();
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cmc-fyc]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
